// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CancelAppointment from './data'

export default function CancelAppointmentFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CancelAppointment">
      <CancelAppointment {...props}>
        {children}
      </CancelAppointment>
    </Flow>
  )
}
